var _defs, _use, _use2, _use3, _use4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-109 104a104 104 0 0 0 0-208h218a104 104 0 0 0 0 208z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M-55 74a55 55 0 0 1 110 0V-74a55 55 0 0 1-110 0z",
    clipPath: "url(#a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(90)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h300v200H0z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 0v80H0v40h130v80h40v-80h130V80H170V0h-40z",
    style: {
      fill: "red"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "red",
    transform: "translate(64.45 39.45)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "red",
    transform: "translate(235.55 160.55)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "red",
    transform: "translate(235.55 39.45)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "red",
    transform: "translate(64.45 160.55)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGe);
export default __webpack_public_path__ + "static/media/ge.48336282e4e09ac51d69739bb7558617.svg";
export { ForwardRef as ReactComponent };